module.exports = __webpack_public_path__ + "img/jardin9.bf1e794c.jpg";